export default __webpack_public_path__ + "static/media/credit.8f12a578.png";